// @owners { team: patient-fulfillment }
import { type Address, type DeliveryDetails, type LightDelivery } from '~shared/types';

export const formatDeliveryDetails = (
  address: Address | undefined,
  upcomingDelivery: LightDelivery | undefined,
): DeliveryDetails | undefined => {
  return upcomingDelivery?.date && address
    ? {
        address,
        date: upcomingDelivery.date,
        startTime: upcomingDelivery.deliver_after,
        endTime: upcomingDelivery.deliver_before,
        deliveryMethod: upcomingDelivery.delivery_method,
        status: upcomingDelivery.status,
      }
    : undefined;
};

export const formatDeliveredMethod = (deliveryMethod?: string): string => {
  switch (deliveryMethod) {
    case 'courier':
      return 'Delivered via courier';
    case 'pickup':
      return 'Picked up at pharmacy';
    case 'fedex_standard_overnight':
    case 'fedex_priority_overnight':
      return 'Delivered via FedEx';
    case 'usps_priority':
    case 'usps_ground_advantage':
    case 'usps_first':
      return 'Delivered via USPS';
    default:
      return 'Delivered';
  }
};
